import React from 'react';

import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';
import { Assignee } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Assignee/Assignee';
import { Comments } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Comments/Comments';
import { Description } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Description/Description';
import { Distribution } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Distribution/Distribution';
import { DurationVariance } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/DurationVariance/DurationVariance';
import { ImpactType } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/ImpactType/ImpactType';
import { Probability } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Probability/Probability';
import { Tags } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Tags/Tags';

export const Details = () => {
    return (
        <div className={classes.cardDetailsContainer}>
            <div className={classes.leftSection}>
                <Description />
                <Comments />
            </div>
            <div className={classes.rightSection}>
                <Tags />
                <Assignee />
                <Probability />
                <Distribution />
                <ImpactType />
                <DurationVariance />
            </div>
        </div>
    );
};
